// extracted by mini-css-extract-plugin
export var indeterminate = "_2e-6";
export var md = "_2e-5";
export var semantic = "_2e-7";
export var sm = "_2e-4";
export var text = "_2e-8";
export var toggleControl = "_2e-0";
export var toggleInput = "_2e-1";
export var toggleSwitch = "_2e-2";
export var xs = "_2e-3";